// ┌─────────────────────────────────────────────────────────────────────────┐
// │ Registre de programes de FITXER (standalonePrograms/) — NOMÉS standalone. │
// └─────────────────────────────────────────────────────────────────────────┘
//
// El pobla `main.js` amb un `import.meta.glob` de Vite. En mode EMBEGUT a SherpaCRM
// s'entra per `EmbeddedApp.vue` (webpack) i `main.js` NO s'executa → el registre
// queda buit i no s'afegeix cap programa de component (comportament desitjat).
//
// Un programa de fitxer té la MATEIXA forma que un del catàleg (perquè els stores
// el mesclin sense distingir-lo en execució) més un camp `origin: 'component'`:
//   { id, origin:'component', name, description, type, order, scope_mode,
//     field_types:[], aliases:[], matchAll:false, dependencies:[], code }
// `code` és la font del mòdul (mateixa que executa el catàleg via Blob+import), i
// serveix també per PROMOURE el programa al model del client més endavant.

let programs = [];
// Dependències de FITXER (standalonePrograms/dependencies/): [{ name, type:'js'|'json', content }].
let deps = [];
// Dependències del MODEL (catàleg), carregades per API: [{ name, type, content }].
let modelDeps = [];
// Versió del registre: puja a cada canvi (programes/deps/model). Els stores la
// comparen per saber si han de recarregar/reinstanciar després d'una edició a l'ABM.
let version = 0;
export function getRegistryVersion() {
  return version;
}

export function setStandaloneDeps(list) {
  deps = Array.isArray(list) ? list : [];
  version += 1;
}
export function getStandaloneDeps() {
  return deps;
}
export function setModelDeps(list) {
  modelDeps = Array.isArray(list) ? list : [];
  version += 1;
}
export function getModelDeps() {
  return modelDeps;
}
// Resol una dependència pel nom: primer les de fitxer (local), després les del model.
// Així un programa en local pot referenciar tant les seves com les del catàleg.
export function getDependency(name) {
  return deps.find((d) => d.name === name) || modelDeps.find((d) => d.name === name) || null;
}

// Construeix una entrada de registre a partir de la `meta` d'un programa + la seva
// font. Ho fan servir tant main.js (glob de Vite en arrencada) com el panell ABM
// (Blob-import en viu en desar), perquè la forma sigui idèntica. `meta.dependencies`
// és una llista de NOMS; es resolen contra el registre de dependències a
// [{ name, type, content }] (el que esperen els stores per omplir ctx.deps).
export function buildProgramEntry(meta, source, folder, fileBaseName = '') {
  const m = meta || {};
  const name = m.name || fileBaseName;
  const depNames = Array.isArray(m.dependencies) ? m.dependencies : [];
  return {
    id: `component:${name}`,
    origin: 'component',
    name,
    description: m.description || '',
    type: m.type || (folder === 'correction' ? 'correction' : 'compute'),
    order: m.order != null ? String(m.order) : '0',
    scope_mode: m.scope_mode || 'ALL',
    field_types: Array.isArray(m.field_types) ? m.field_types : [],
    aliases: Array.isArray(m.aliases) ? m.aliases : [],
    // Coincidència d'àlies (M046): true = exigeix TOTS els àlies; absent/false = ALGUN (def.).
    matchAll: m.matchAll === true,
    dependencies: depNames.map((n) => getDependency(n)).filter(Boolean),
    code: source || '',
  };
}

export function setStandalonePrograms(list) {
  programs = Array.isArray(list) ? list : [];
  version += 1;
}

export function getStandalonePrograms() {
  return programs;
}

// Programes de CORRECCIÓ (pas 6). type === 'correction'.
export function getCorrectionStandalonePrograms() {
  return programs.filter((p) => /^correction$/i.test(p.type || ''));
}

// Programes de CÀLCUL (pas 7): preprocessing + compute (tot menys correction).
export function getCalculationStandalonePrograms() {
  return programs.filter((p) => !/^correction$/i.test(p.type || ''));
}
